module.exports = __webpack_public_path__ + "static/giff-c8206bedcc9a2bffc4e57f71c3687de4.png";